import ModalResetPassword from './modalResetPassword';  

export default ModalResetPassword;